var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('Default',[_c('v-card-text',{staticClass:"mt-8"},[_vm._v(" Loading... "),_c('v-progress-linear',{attrs:{"indeterminate":""}})],1)],1):_vm._e(),(!_vm.loading)?_c('router-view'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }